export const ReportsManagementRoutes = [
    {
        "url": "/reporting",
        "name": "appLayout.reports",
        "type": "frontend",
        "loginRequired": true,
        "abstract": true,
        "component": "reportsManagementContainer",
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["reports-management", "reports"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./reports-management.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/attestation-report",
        "name": "appLayout.reports.attestation-report",
        "type": "frontend",
        "loginRequired": true,
        "showGlobalSearch": true,
        "views": {
            "content": {
                "component": "attestationReport"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["reports", "save_views"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Attestation Report"
            }
        ]
    },
    {
        "url": "/employee-docs-detailed-report",
        "name": "appLayout.reports.employee-docs-detailed",
        "type": "frontend",
        "loginRequired": true,
        "showGlobalSearch": true,
        "views": {
            "content": {
                "component": "employeeDocsDetailedContainer"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["reports"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Employee Docs Detailed"
            }
        ]
    },
    {
        "url": "/rewards-audit-log-report",
        "name": "appLayout.reports.rewards-audit-log-report",
        "platformPage": true,
        "loginRequired": true,
        "showGlobalSearch": true,
        "views": {
            "content": {
                "component": "rewardsAuditReportContainer"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["reports", "save_views"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./reports-management.downgrade.module");
                }
            }
        ],
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Rewards Audit Log Report"
            }
        ]
    }
];
//# sourceMappingURL=reports-management.routes.js.map